import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation($id: String!) {
    deleteOnePesticide(
      where: { id: $id }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fitofármaco eliminado`, mutationTypes.DELETE)
)

